import { Popover } from "@InnoUI/";
import theme from "@theme/";
import React from "react";

const EmailDetailsTooltip = ({
  data = [],
  maxWidth = "150px",
  popoverWidth = "200px",
  fontSize = "11px",
  opacity,
  color,
  fontWeight,
}) => {
  const hasData = data && data.length > 0;

  // Only render the Popover if there is data
  if (!hasData) {
    return (
      <p
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: maxWidth,
          paddingBlock: "0px",
          marginBlock: "0px",
          fontSize: fontSize,
          opacity: opacity,
          color: color,
          fontWeight: fontWeight,
          height: "15px",
        }}
      >
        {"N/A"}
      </p>
    );
  }

  return (
    <Popover
      sx={{ cursor: "pointer" }}
      buttonLabel={{
        icon: (
          <p
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: maxWidth,
              paddingBlock: "0px",
              marginBlock: "0px",
              fontSize: fontSize,
              opacity: opacity,
              color: color,
              fontWeight: fontWeight,
              height: "17.5px",
            }}
          >
            {data.map((user) => user?.name).join(", ") || "N/A"}
          </p>
        ),
      }}
      popoverContent={
        <table style={{ width: popoverWidth }}>
          <thead>
            <tr>
              <th
                style={{
                  color: theme.colors.themeColor,
                  borderBottom: `1px solid ${theme.colors.bordertask}`,
                  textAlign: "left",
                  padding: "0px 10px 0px 10px",
                }}
              >
                Name
              </th>
              <th
                style={{
                  color: theme.colors.themeColor,
                  borderBottom: `1px solid ${theme.colors.bordertask}`,
                  textAlign: "left",
                  padding: "0px 10px 0px 10px",
                }}
              >
                Email
              </th>
              <th
                style={{
                  color: theme.colors.themeColor,
                  borderBottom: `1px solid ${theme.colors.bordertask}`,
                  textAlign: "left",
                  padding: "0px 10px 0px 10px",
                }}
              >
                Company
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr key={index}>
                <td
                  style={{
                    borderBottom: `1px solid ${theme.colors.bordertask}`,
                    padding: "0px 10px 0px 10px",
                  }}
                >
                  {item?.name || "N/A"}
                </td>
                <td
                  style={{
                    borderBottom: `1px solid ${theme.colors.bordertask}`,
                    padding: "0px 10px 0px 10px",
                  }}
                >
                  {item?.email || "N/A"}
                </td>
                <td
                  style={{
                    borderBottom: `1px solid ${theme.colors.bordertask}`,
                    padding: "0px 10px 0px 10px",
                  }}
                >
                  {item?.companyName || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      }
    />
  );
};

export default EmailDetailsTooltip;
